var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"tw-text-primary",attrs:{"color":"primary","depressed":"","large":""}},[(_vm.icon)?_c('span',{staticClass:"tw-mr-2"},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("mdi-"+_vm._s(_vm.icon))])],1):_vm._e(),_c('div',{staticClass:"tw-text-sm tw-font-bold tw-capitalize"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }